import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Can} from "../../../../ability-context";
import ErrorUnauthorized from "../../ErrorUnauthorized";
import {fetchUserMedias, resetUserMedias} from "../../../../creators/user.medias";
import {PageLoader} from "../../../components/Loader";
import Thumb from "../../../components/Thumb";
import Pagination from "../../../components/Pagination";
import createLink from "../../../../libs/createLink";
import {Button} from "../../../components/Button";
import Dropdown from "../../../components/Dropdown";
import {fetchCategoriesRootMedia} from "../../../../creators/categories.rootChildrens";
import Aqp from "../../../../libs/mk-react-aqp";

let mapping = {
    'kind': 'type',
    'byCategoryId': 'categorie',
    'sort': 'trie',
};

class ProfileMedias extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            limit: 50,
            page: 1,
            kind : "",
            byCategoryId : "",
            sort: "-createdAt"
        };

        this.aqp = new Aqp(mapping, {
            blacklist: ['limit', 'page'],
            currentLink: createLink('userMedias', this.props.user),
            filterDefault: this.filter
        });

        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: this.props.match.params.page || 1},
        };

        this.getMediasUser = this.getMediasUser.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleFilterSort = this.handleFilterSort.bind(this);
        this.handleFilterKind = this.handleFilterKind.bind(this);
        this.handleFilterCategory = this.handleFilterCategory.bind(this);


        this.props.fetchCategoriesRootMedia();
    }

    getMediasUser(query){
        this.setState({filter : query});
        this.props.fetchUserMedias(this.props.user._id, this.aqp.set(query));
    }

    componentDidMount() {
        this.getMediasUser(this.state.filter);
    }

    componentWillUnmount() {
        this.props.resetUserMedias();
    }


    componentDidUpdate(prevProps) {
        if (prevProps.user._id !== this.props.user._id) {
            let newFilter = {...this.filter};
            this.getMediasUser(this.props.user._id, newFilter);
        }
    }

    handleChangePage(page, link) {
        let filter = {...this.state.filter, page};
        this.getMediasUser(filter);

        if (page === 1) {
            this.props.history.push(link);
        } else {
            this.props.history.push(link + '/' + page);
        }
        window.scrollTo(0, 0);
    }

    handleFilterSort(sortBy = "-createdAt"){
        let filter = {...this.state.filter, page : 1, sort : sortBy}
        this.getMediasUser(filter);
    }

    handleFilterKind(kind = ""){
        let filter = {...this.state.filter, page : 1, kind}
        this.getMediasUser(filter);
    }

    handleFilterCategory(cateId){
        let filter = {...this.state.filter, page : 1, byCategoryId : cateId}
        this.getMediasUser(filter);
    }


    render() {

        let totalPage = this.props.userMedias ? Math.ceil(this.props.userMediasTotal / this.state.filter.limit) : 0;
        let linkPagination = createLink('userMedias', this.props.user);

        let categoryGender = this.props.categories.filter(cat => cat.slug === "genre");
        categoryGender = categoryGender.length ? categoryGender[0].childrens : [];
        let currentCategory = categoryGender.find(cat => cat._id.toString() === this.state.filter.byCategoryId);

        return (
            <Can action="profile-medias" subject="Media" passThrough>
                {can => {
                    if(can){
                        return !this.props.userMediasInitialized ? (
                            <div className="main-wrapper profile-medias card big">
                                <PageLoader/>
                            </div>
                        ) : (
                            <div className="main-wrapper profile-medias card big">
                                <div className={"options"}>
                                    <div className={"option-filter"}>
                                        <Dropdown activableComponent={(
                                            <Button size={"small"}
                                                    icon={"picture"}
                                                    className={"media-btn-settings mr-8"}
                                            />
                                        )}>
                                            <ul className="dropdown-menu media-filter">
                                                <li className={`menu-item ${this.state.filter.kind === '' ? 'active' : ''}`}
                                                    onClick={() => {
                                                        this.handleFilterKind('')
                                                    }} >Tout
                                                </li>
                                                <li className={`menu-item ${this.state.filter.kind === 'gallery' ? 'active' : ''}`}
                                                    onClick={() => {
                                                        this.handleFilterKind('gallery')
                                                    }} >Photos
                                                </li>
                                                <li className={`menu-item ${this.state.filter.kind === 'video' ? 'active' : ''}`}
                                                    onClick={() => {
                                                        this.handleFilterKind('video')
                                                    }} >Vidéos
                                                </li>
                                            </ul>
                                        </Dropdown>
                                        <Dropdown activableComponent={(
                                            <Button size={"small"}
                                                    icon={"genre"}
                                                    className={"media-btn-settings"}
                                            />
                                        )}>
                                            <ul className="dropdown-menu media-filter">
                                                <li className={`menu-item ${this.state.filter.byCategoryId === '' ? 'active' : ''}`}
                                                    onClick={() => {
                                                        this.handleFilterCategory('')
                                                    }} >Tout
                                                </li>
                                                {categoryGender.map(cat =>(
                                                    <li key={cat._id} className={`menu-item ${this.state.filter.byCategoryId === cat._id.toString() ? 'active' : ''}`}
                                                        onClick={() => {
                                                            this.handleFilterCategory(cat._id.toString())
                                                        }} >{cat.title}
                                                    </li>
                                                ))}
                                            </ul>
                                        </Dropdown>
                                    </div>
                                    <div className={"option-sort"}>
                                        <div className={"mr-16"}>
                                            {currentCategory ? `${currentCategory.title} ` : ""}
                                            {this.props.userMediasTotal || 0}
                                            {this.state.filter.kind === "" ? " Médias" : this.state.filter.kind === "video" ? " Vidéos" : " Photos"}

                                        </div>
                                        <Dropdown activableComponent={(
                                            <Button size={"small"}
                                                    icon={"sliders"}
                                                    className={"media-btn-settings"}
                                            />
                                        )}>
                                            <ul className="dropdown-menu media-filter">
                                                <li className={`menu-item ${this.state.filter.sort === '-createdAt' ? 'active' : ''}`}
                                                    onClick={() => {
                                                        this.handleFilterSort('-createdAt')
                                                    }} >Mis à jour récemment
                                                </li>
                                                <li className={`menu-item ${this.state.filter.sort === 'createdAt' ? 'active' : ''}`}
                                                    onClick={() => {
                                                        this.handleFilterSort('createdAt')
                                                    }} >Date de début
                                                </li>
                                                <li className={`menu-item ${this.state.filter.sort === '-count.comment' ? 'active' : ''}`}
                                                    onClick={() => {
                                                        this.handleFilterSort('-count.comment')
                                                    }} >Avec le plus de réponses
                                                </li>
                                                <li className={`menu-item ${this.state.filter.sort === '-count.like' ? 'active' : ''}`}
                                                    onClick={() => {
                                                        this.handleFilterSort('-count.like')
                                                    }} >Le plus like
                                                </li>
                                            </ul>
                                        </Dropdown>
                                    </div>
                                </div>
                                {totalPage > 1 && (
                                    <Pagination
                                        currentPage={this.state.filter.page}
                                        pagesCount={totalPage}
                                        handleChangePage={this.handleChangePage}
                                        link={linkPagination}
                                    />
                                )}
                                <div className={"wrapper-thumb"}>
                                    {Array.isArray(this.props.userMedias) && this.props.userMedias.map((media) => (
                                        <Thumb key={media._id} {...media} cropTitle={45} />
                                    ))}
                                    {this.props.userMediasTotal === 0 && (
                                        <div className={"no-content"}>Il n'y a aucune media</div>
                                    )}
                                </div>
                                {totalPage > 1 && (
                                    <Pagination
                                        currentPage={this.state.filter.page}
                                        pagesCount={totalPage}
                                        handleChangePage={this.handleChangePage}
                                        link={linkPagination}
                                    />
                                )}
                            </div>
                        )
                    }
                    else{
                        return <div className={"mt-16"}><ErrorUnauthorized /></div>
                    }
                }}
            </Can>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        userMedias: state.userMedias.data,
        userMediasLoading: state.userMedias.loading,
        userMediasInitialized: state.userMedias.initialized,
        userMediasTotal: state.userMedias.total,

        categories: state.categoriesRoot.data,
        categoriesLoading: state.categoriesRoot.loading,
        categoriesInitialized: state.categoriesRoot.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserMedias,
    resetUserMedias,
    fetchCategoriesRootMedia
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ProfileMedias);


